console.log("Three.js story script loaded");

(async function () {
  const stories = window.__threeJsStory || [];
  if (!stories.length) return;

  const THREE = await import("https://cdn.jsdelivr.net/npm/three@0.160.0/build/three.module.js");
  const { GLTFLoader } = await import("https://cdn.jsdelivr.net/npm/three@0.160.0/examples/jsm/loaders/GLTFLoader.js");
  const gsapMod = await import("https://cdn.jsdelivr.net/npm/gsap@3.12.5/index.js");
  const ScrollTriggerMod = await import("https://cdn.jsdelivr.net/npm/gsap@3.12.5/ScrollTrigger.js");

  const gsap = gsapMod.gsap || gsapMod.default || gsapMod;
  const ScrollTrigger = ScrollTriggerMod.ScrollTrigger || ScrollTriggerMod.default || ScrollTriggerMod;

  gsap.registerPlugin(ScrollTrigger);

  stories.forEach((story) => {
    const section = document.getElementById(`ThreeJsStory-${story.id}`);
    const canvas = document.getElementById(`ThreeJsCanvas-${story.id}`);
    if (!section || !canvas) return;

    const scene = new THREE.Scene();
    scene.fog = new THREE.Fog(0x000000, 6, 18);

    const camera = new THREE.PerspectiveCamera(35, 1, 0.1, 100);
    camera.position.set(0, 0.3, 6);

    const renderer = new THREE.WebGLRenderer({
      canvas,
      antialias: true,
      alpha: true,
      powerPreference: "high-performance"
    });

    renderer.outputColorSpace = THREE.SRGBColorSpace;
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.25;
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

    const root = new THREE.Group();
    scene.add(root);

    scene.add(new THREE.AmbientLight(0xffffff, 1.6));

    const key = new THREE.DirectionalLight(0xffffff, 3);
    key.position.set(2, 4, 6);
    scene.add(key);

    const rim = new THREE.DirectionalLight(0x8fd3ff, 1.8);
    rim.position.set(-4, 1, -3);
    scene.add(rim);

    const fill = new THREE.PointLight(0xff7a45, 2.5, 20);
    fill.position.set(0, -1, 3);
    scene.add(fill);

    const loader = new GLTFLoader();
    let model = null;
    let mixer = null;
    const clock = new THREE.Clock();

    loader.load(
      story.modelUrl,
      (gltf) => {
        model = gltf.scene;
        root.add(model);

        model.traverse((obj) => {
          if (obj.isMesh && obj.material) {
            if ("metalness" in obj.material) obj.material.metalness = 0.25;
            if ("roughness" in obj.material) obj.material.roughness = 0.55;
          }
        });

        const box = new THREE.Box3().setFromObject(model);
        const size = new THREE.Vector3();
        const center = new THREE.Vector3();
        box.getSize(size);
        box.getCenter(center);

        model.position.sub(center);

        const maxDim = Math.max(size.x, size.y, size.z);
        model.scale.setScalar(2.6 / maxDim);
        root.position.set(0, -0.2, 0);

        if (gltf.animations && gltf.animations.length) {
          mixer = new THREE.AnimationMixer(model);
          gltf.animations.forEach((clip) => mixer.clipAction(clip).play());
        }

        ScrollTrigger.refresh();
      },
      undefined,
      (error) => {
        console.error("GLB load error:", error);
      }
    );

    function resize() {
      const sticky = section.querySelector(".threejs-story__sticky");
      const rect = sticky.getBoundingClientRect();
      camera.aspect = rect.width / rect.height;
      camera.updateProjectionMatrix();
      renderer.setSize(rect.width, rect.height, false);
    }

    resize();
    window.addEventListener("resize", resize);

    gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top top",
        end: "bottom bottom",
        scrub: 1
      }
    })
    .to(camera.position, { z: 3.4, y: 0.1, ease: "none" }, 0)
    .to(root.rotation, { y: Math.PI * 1.25, x: 0.12, ease: "none" }, 0)
    .to(root.scale, { x: 1.1, y: 1.1, z: 1.1, ease: "none" }, 0)
    .to(section.querySelector(".panel-1"), { opacity: 1, y: 0, duration: 0.2 }, 0.08)
    .to(section.querySelector(".panel-1"), { opacity: 0, y: -20, duration: 0.2 }, 0.26)
    .to(section.querySelector(".panel-2"), { opacity: 1, y: 0, duration: 0.2 }, 0.38)
    .to(section.querySelector(".panel-2"), { opacity: 0, y: -20, duration: 0.2 }, 0.58)
    .to(section.querySelector(".panel-3"), { opacity: 1, y: 0, duration: 0.2 }, 0.72);

    function animate() {
      requestAnimationFrame(animate);
      const dt = clock.getDelta();
      if (mixer) mixer.update(dt);
      if (model) model.rotation.y += 0.0015;
      renderer.render(scene, camera);
    }

    animate();
  });
})();